import * as React from "react";

import "./address-lists-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {keyed}         from "@Common/react/keyed";
import {UseState}      from "@Common/react/use-state";
import {isDevQuan}     from "@Common/ui-components/debug/is-dev-quan";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";
import {waitTimeout}   from "@Common/utils/wait-timeout";

import {ListView} from "./list-view/list-view";

export const AddressListsModal = ({next: rootNext}) => cs(
    ["creating", (_, next) => UseState({next})],
    ["listView", (_, next) => ListView({next})],
    ["modal", ({creating, listView}) => ModalService3({
        xdQaName: "Address Lists Modal",
        initShow: !!isDevQuan(),
        width: 800,
        rootNext,
        contentService: ({params, close, next}) => (
            creating.value == null ? cs(
                keyed("list-view"),
                () => (
                    next({
                        // @ts-ignore
                        getContent: () => listView.render({
                            onCreate: (service) => {
                                creating.onChange({service});
                            }
                        }),
                    })
                ),
            ) : cs(
                keyed("service-view"),
                ["service", ({}, next) => creating.value.service({
                    onClose: () => creating.onChange(null),
                    onCancel: () => creating.onChange(null),
                    cancelLabel: "Back",
                    countryCode: "US",
                    onCreated: () => listView.reload(),
                    entityId: params.officeId,
                    next,
                })],
                ({service}) => next({
                    ...service,
                    onPassiveClose: async () => {
                        const result = await service.onClose?.();
                        if (result !== false) {
                            // noinspection ES6MissingAwait
                            (async () => {
                                await waitTimeout(300);
                                creating.onChange(null);
                            })();
                        }
                        return result;
                    },
                }),
            )
        ),
    })],
);
